/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetOrganizationResponseData,
  GetOrganizationResponseDataFromJSON,
  GetOrganizationResponseDataFromJSONTyped,
  GetOrganizationResponseDataToJSON
} from './GetOrganizationResponseData'

/**
 *
 * @export
 * @interface UpdateOrganizationAdvertisementResponse
 */
export interface UpdateOrganizationAdvertisementResponse {
  /**
   *
   * @type {number}
   * @memberof UpdateOrganizationAdvertisementResponse
   */
  status?: number
  /**
   *
   * @type {GetOrganizationResponseData}
   * @memberof UpdateOrganizationAdvertisementResponse
   */
  data?: GetOrganizationResponseData
}

export function UpdateOrganizationAdvertisementResponseFromJSON(json: any): UpdateOrganizationAdvertisementResponse {
  return UpdateOrganizationAdvertisementResponseFromJSONTyped(json, false)
}

export function UpdateOrganizationAdvertisementResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateOrganizationAdvertisementResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetOrganizationResponseDataFromJSON(json['data'])
  }
}

export function UpdateOrganizationAdvertisementResponseToJSON(
  value?: UpdateOrganizationAdvertisementResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetOrganizationResponseDataToJSON(value.data)
  }
}
